/**
 * StandaloneSpinner — Exact port of AngularJS loading-widget + content.html spinner.
 *
 * Reads G_SETTINGS.loadingSpinner to show the user-selected GIF.
 * CSS matches widgets.css lines 501-534.
 * GIF files located at /Content/images/spinners/[filename]
 *
 * Shared between AppLayout (in-app loading overlay) and StandaloneBootstrap
 * (initial language-pack fetch) so every full-screen loading state in the
 * standalone shell looks identical.
 */

import { useMemo } from 'react';
import { useSettings } from '@/store';

export function StandaloneSpinner() {
  const settings = useSettings();
  const spinnerFilename = useMemo(() => {
    if (settings?.loadingSpinner) return settings.loadingSpinner;

    try {
      const stored = localStorage.getItem('userSettings');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed.loadingSpinner) return parsed.loadingSpinner;
      }
    } catch {
      // corrupted
    }

    return 'safeview.gif';
  }, [settings]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999999,
      }}
    >
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          background: 'transparent',
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <img src={`/Content/images/spinners/${spinnerFilename}`} alt='Loading...' />
      </div>
    </div>
  );
}
